import src from "IMAGE";
export default { src, width: 711, height: 384, blurWidth: 0, blurHeight: 0};
